import { render } from "./MainView.vue?vue&type=template&id=5209ca7f&scoped=true"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"

import "./MainView.vue?vue&type=style&index=0&id=5209ca7f&scoped=true&lang=css"
import "./MainView.vue?vue&type=style&index=1&id=5209ca7f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5209ca7f"]])

export default __exports__